export default __webpack_public_path__ + "static/media/plus_green.9b60bd18.svg";